export default async function (action, args, displayId, payload) {
    console.log('cart-rule-action:remove_product', { action, args })

    const store = window.addiesaas.store

    const items = Object.values(store.getters['Shop/Orders/Cart/cartItems'])
    const productItems = items.filter(item => item.payload.product_id == action.options.product_id)

    let countToRemove = action.options.count || true

    payload.upsell_value = 0

    for (const item of productItems) {
        if (countToRemove === false) {
            await store.dispatch('Shop/Orders/Cart/removeCartItem', { id : item.id })

            payload.upsell_value -= item.product.price * (item.payload.count || 1)
        } else {
            const itemCount = item.payload.count || 1
            if (itemCount <= countToRemove) {
                countToRemove = itemCount
            }
            const payload = Object.assign({}, item.payload)
            payload.count -= countToRemove
            if (payload.count > 0) {
                await store.dispatch('Shop/Orders/Cart/updateCartItem', {
                    id: item.id,
                    payload
                })
            } else {
                await store.dispatch('Shop/Orders/Cart/removeCartItem', { id : item.id })
            }

            const product = Object.values(window.addiesaas.products.types)
                .flat(1)
                .find(p => p.id == item.payload.product_id)
            payload.upsell_value -= product.price * countToRemove

            countToRemove -= itemCount

            if (countToRemove <= 0) {
                break
            }
        }
    }

    window.addiesaas.$core.EventBus.$emit('cart.validate')
}
